import { render, staticRenderFns } from "./PackageRootUpdateDialog.vue?vue&type=template&id=065b45f1&scoped=true"
import script from "./PackageRootUpdateDialog.vue?vue&type=script&lang=js"
export * from "./PackageRootUpdateDialog.vue?vue&type=script&lang=js"
import style0 from "./PackageRootUpdateDialog.vue?vue&type=style&index=0&id=065b45f1&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065b45f1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('065b45f1')) {
      api.createRecord('065b45f1', component.options)
    } else {
      api.reload('065b45f1', component.options)
    }
    module.hot.accept("./PackageRootUpdateDialog.vue?vue&type=template&id=065b45f1&scoped=true", function () {
      api.rerender('065b45f1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/Package/PackageRootUpdateDialog.vue"
export default component.exports